import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModalOptimizationService {
  private modalSubject = new Subject<any>();
  modalState = this.modalSubject.asObservable();

  constructor() {}

  show(optim?: any) {
    this.modalSubject.next(optim);
  }

  hide() {
    this.modalSubject.next(undefined);
  }
}
